// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestProfile(id, token) {
  return {
    type: types.PROFILE_REQUEST,
    id,
    token,
  };
}
export function profileRequestFailed(errors) {
  return {
    type: types.PROFILE_REQUEST_FAILED,
    errors
  };
}
export function profileRequestSuccess(response) {
  return {
    type: types.PROFILE_REQUEST_SUCCESS,
    response
  };
}

// FIELDS

export function resetErrorsAndSuccess() {
  return {
    type: types.RESET_ERRORS_AND_SUCCESS,
  };
}

export function changeField(value, field) {
  return {
    type: types.PROFILE_FIELD_CHANGE,
    value,
    field
  };
}

export function changeErrors(field, error) {
  return {
    type: types.PROFILE_ERRORS_CHANGE,
    field,
    error
  };
}

// ----

export function changePasswordRequest(data) {
  return {
    type: types.PROFILE_CHANGE_PASSWORD_REQUEST,
    ...data,
  };
}

export function setSuccess(data) {
  return {
    type: types.SET_SUCCESS,
    data,
  };
}

// ----
export function requestProfileEdit(profile, id, token, pageInfo, to) {
  return {
    type: types.PROFILE_EDIT_REQUEST,
    pageInfo,
    profile,
    id,
    token,
    to,
  };
}

export function changeFieldAddress(value, field) {
  return {
    type: types.ADDRESS_FIELD_CHANGE,
    value,
    field
  };
}

export function changeFieldPayment(value, field) {
  return {
    type: types.PAYMENT_FIELD_CHANGE,
    value,
    field
  };
}

export function changeFieldPaypal(value, field) {
  return {
    type: types.PAYPAL_FIELD_CHANGE,
    value,
    field
  };
}

export function changeFieldConfirmPaypal(value, field) {
  return {
    type: types.CONFIRM_PAYPAL_FIELD_CHANGE,
    value,
    field
  };
}

export function profileEditRequestSuccess(data) {
  return {
    type: types.PROFILE_EDIT_REQUEST_SUCCESS,
    data,
  };
}

export function profileEditRequestFailed(data) {
  return {
    type: types.PROFILE_EDIT_REQUEST_FAILED,
    data,
  };
}

export function changeFieldChangePassword(value, field) {
  return {
    type: types.CHANGE_PASSWORD_FIELD,
    value,
    field
  };
}

export function resetPasswordChanges() {
  return {
    type: types.RESET_PASSWORD_CHANGES,
  };
}

export function validatePayPalEmail(paypal) {
  return {
    type: types.VALIDATE_PAYPAL_EMAIL_REQUEST,
    paypal
  };
}

export function validatePayPalEmailSuccess(response) {
  return {
    type: types.VALIDATE_PAYPAL_EMAIL_REQUEST_SUCCESS,
    response
  };
}

export function setConfirmPaypalNull(isChangeFirstTime) {
  return {
    type: types.SET_CONFIRM_PAYPAL_NULL,
    isChangeFirstTime
  };
}

export function setIsChangeFirstTime(isChangeFirstTime) {
  return {
    type: types.SET_IS_CHANGE_FIRST_TIME,
    isChangeFirstTime
  };
}

export function verifyPhoneNumber(data, dataForNextRequest) {
  return {
    type: types.VERIFY_PHONE_NUMBER,
    data,
    dataForNextRequest,
  };
}
export function verifyPhoneNumberFailed(data) {
  return {
    type: types.VERIFY_PHONE_NUMBER_FAILED,
    data,
  };
}

export function verifyBankAccount(data, dataForNextRequest) {
  return {
    type: types.VERIFY_BANK_ACCOUNT,
    data,
    dataForNextRequest,
  };
}
export function verifyBankAccountFailed(data) {
  return {
    type: types.VERIFY_BANK_ACCOUNT_FAILED,
    data,
  };
}

export function checkoutForTradeCustomer(paymentType) {
  return {
    type: types.CHECKOUT_FOR_TRADE_CUSTOMER,
    paymentType,
  };
}

export function resetAddress() {
  return {
    type: types.RESET_ADDRESS,
  };
}
